import * as tslib_1 from "tslib";
import { DrilldownLevels as DrilldownLevelsEnum, DrilldownLevelsList } from "../../constants";
import moment from 'moment-timezone';
import React from 'react';
import { formatLevelDate, getLevelFromDateRange } from '../../utils/date';

function DrilldownLevels(props) {
  var cx = props.cx,
      dateRange = props.dateRange,
      timezone = props.timezone,
      drilldownPoint = props.drilldownPoint,
      actions = props.actions;
  var dateRangeLevel = getLevelFromDateRange(dateRange, timezone);
  var levels = DrilldownLevelsList.slice(DrilldownLevelsList.indexOf(dateRangeLevel), DrilldownLevelsList.indexOf(drilldownPoint.level) + 1);
  var date = drilldownPoint.date;
  return levels.map(function (level, index) {
    return [React.createElement("i", {
      key: "arrow",
      className: "icon-arrow-right"
    }), React.createElement("span", {
      key: index,
      className: cx('drilldown-level'),
      onClick: function onClick() {
        return actions.changeDrilldownPoint({
          level: level,
          date: date
        });
      }
    }, level === DrilldownLevelsEnum.WEEK && 'Wk ', formatLevelDate(level, moment(date).tz(timezone)))];
  });
}

function AllDrilldownLevels(props) {
  var cx = props.cx,
      style = props.style,
      drilldownPoint = props.drilldownPoint,
      actions = props.actions;
  return React.createElement("div", {
    className: cx('drilldown-levels'),
    style: style
  }, React.createElement("span", {
    className: cx('drilldown-level'),
    onClick: function onClick() {
      return actions.changeDrilldownPoint(null);
    }
  }, "All Time"), drilldownPoint != null && React.createElement(DrilldownLevels, tslib_1.__assign({
    drilldownPoint: drilldownPoint
  }, props)));
}

export default AllDrilldownLevels;